import * as React from "react";
const SvgFiBrandsTumblr = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 25 24"
    {...props}
  >
    <path
      fill="#151A2D"
      d="M15.401 24c-3.76 0-6.561-1.857-6.561-6.299v-7.115H5.423V6.733C9.183 5.796 10.755 2.69 10.936 0h3.905v6.108h4.555v4.477H14.84v6.195c0 1.857.976 2.499 2.53 2.499h2.205V24z"
    />
  </svg>
);
export default SvgFiBrandsTumblr;
